module.exports = __webpack_public_path__ + "b01319ba76f0979cb2fda980c405b73d.woff";